import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { useAuth } from '../../../hooks/useAuth';
import { useNavigate } from '../../../hooks/useNavigate';
import { Card } from '../../common/Card';
import { View } from '../../common/View';

import styles from '../google-sign-in.module.scss';

import { LoginForm } from './LoginForm';
import { useGoogleLogin } from '@react-oauth/google';

type LoginProps = {};

export function Login({}: LoginProps) {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const email = searchParams.get('email');

  useEffect(() => {
    async function run() {
      if (isAuthenticated) {
        navigate('/');
      }
    }

    run();
  }, []);

  const loginWithGoogle = useGoogleLogin({
    flow: 'auth-code',
    ux_mode: 'redirect',
    redirect_uri: window.location.origin + '/auth-callback/google',
  });

  return (
    <View
      style={{
        margin: '0 auto',
        justifyContent: 'center',
        width: '100%',
        maxWidth: 400,
      }}
    >
      <Card style={{ padding: 24 }}>
        <h2>Sign-in</h2>
        <LoginForm initialEmail={email} />

        <View style={{ marginTop: '8px', padding: '8px' }}>
          <button
            type="button"
            className={styles.loginWithGoogleGoogleBtn}
            onClick={() => loginWithGoogle()}
          >
            Sign in with Google
          </button>
        </View>
      </Card>
    </View>
  );
}
